import wxJsBridge from 'weixin-js-sdk'

export const isAndroid = function () {
    return uni.getSystemInfoSync().platform === 'android'
}

export const isIOS = function () {
    return uni.getSystemInfoSync().platform === 'ios'
}

export const baseParentInvoke = (funName, params) => {
    try {
        // 微信小程序
        if (window.__wxjs_environment == 'miniprogram') {
            return jWeixin.miniProgram[funName](params)
            // 安卓环境
        } else if (isAndroid()) {
            if (typeof params == 'object') {
                return jsBridge[funName](JSON.stringify(params))
            } else if (typeof params == 'string') {
                return jsBridge[funName](params)
            } else {
                return jsBridge[funName]()
            }
            // IOS环境
        } else if (isIOS()) {
            if (typeof params == 'object') {
                return window.webkit.messageHandlers[funName].postMessage(JSON.stringify(params));
            } else if (typeof params == 'string') {
                return window.webkit.messageHandlers[funName].postMessage(params);
            } else {
                return window.webkit.messageHandlers[funName].postMessage({});
            }
        } else if (uni[funName]) {
            // uni-app 内部
            return uni[funName](params)
        }
    } catch (e) {

    }
}

const methods = [
    'navigateTo',

    // 重定向 src , title
    "redirectTo",

    'navigateBack',
    'postMessage',
    'switchTab',
    // 设置标题
    'setTitle',
    'getAccessToken',
    // 会员支付
    'createVipOrder',
    // 继续支付
    'createAssistantOrder',
    // 添加订单
    'addOrder',
    // 删除订单
    'deleteOrder',
    //更新订单
    'updateOrder',
    // 拨打电话
    'callPhone',
    // 延长支付
    'createAssistantDelayOrder',
]

/**
 *
 * @returns {{}}
 */
const initJsBridge = () => {
    let o = {};
    methods.forEach(m => {
        o[m] = (params) => {
            try {
                return baseParentInvoke(m, params)
            } catch (e) {
                console.error(e)
                return ''
            }
        }
    })
    return o;
}

export const xApp = {};
['navigateTo', "redirectTo", 'navigateBack', 'postMessage', 'switchTab'].forEach(m => {
    xApp[m] = (params) => {
        wxJsBridge.miniProgram[m] && wxJsBridge.miniProgram[m](params)
    }
})

export const wxBridge = wxJsBridge;

export default initJsBridge();
